import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { outreachBuilderPath } from '../outreachPaths';
import { homeMessages } from '../home/homeMessages';

interface PitchASongButtonProps {
  /** The release the builder opens with; `null` lets the builder ask. */
  song: string | null;
}

/** "Pitch a song", the main button of every Pitch tab (design navigation-v2 d 4a). */
const PitchASongButtonComponent: React.FC<PitchASongButtonProps> = ({ song }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <SMLButton
      size="sm"
      color="primary"
      omitCap
      leftIcon={faPaperPlane}
      // eslint-disable-next-line no-void
      onClick={() => void navigate(outreachBuilderPath({ song }))}
      testID="pitch-a-song"
    >
      {intl.formatMessage(homeMessages.pitchASong)}
    </SMLButton>
  );
};

export const PitchASongButton = TypedMemo(PitchASongButtonComponent);
